export class System {
    whiteLabelProviders: any[] = [];
    system: any;
    whiteLabelProvidersAmount: number = 0;
    organisationAmount: number = 0;
    licencesAmount: number = 0;
    licencesActive: number = 0;
}
